import { render, staticRenderFns } from "./SwitchBatchModal.vue?vue&type=template&id=36a8db5c&scoped=true"
import script from "./SwitchBatchModal.vue?vue&type=script&lang=js"
export * from "./SwitchBatchModal.vue?vue&type=script&lang=js"
import style0 from "./SwitchBatchModal.vue?vue&type=style&index=0&id=36a8db5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a8db5c",
  null
  
)

export default component.exports